module.exports = __webpack_public_path__ + "public/Icons/right.svg?e69f74c8";